import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, assetUrl } from "@/lib/api";
import { Leaf, CaretRight } from "@phosphor-icons/react";
import ShareButton from "@/components/ShareButton";

const speciesOf = (p) => (p.nature || []).map((n) => n.common_name).filter(Boolean).slice(0, 3);

export default function NatureFeed() {
  const navigate = useNavigate();
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    api.get("/public/nature?limit=8").then((r) => setPhotos(r.data.photos || [])).catch(() => {});
  }, []);
  if (!photos.length) return null;
  return (
    <section className="mx-auto max-w-6xl px-5 pt-14" data-testid="nature-feed">
      <div className="mb-4 flex items-end justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-emerald-600 text-white"><Leaf size={20} weight="fill" /></span>
          <div>
            <p className="overline text-[10px] text-emerald-700">Powered by NaturePulse</p>
            <h2 className="font-display text-xl font-black tracking-tight sm:text-2xl">Nature &amp; wildlife, identified</h2>
          </div>
        </div>
        <Link to="/nature-pulse" data-testid="nature-view-all" className="hidden items-center gap-0.5 text-sm font-bold text-emerald-700 hover:underline sm:flex">
          View all <CaretRight size={14} weight="bold" />
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {photos.map((p) => {
          const species = speciesOf(p);
          return (
            <Link key={p.id} to={`/p/${p.id}`} data-testid={`nature-photo-${p.id}`}
              className="group relative block overflow-hidden rounded-xl bg-zinc-100 ring-1 ring-emerald-600/15">
              <img src={assetUrl(p.image_url)} alt={p.title || "nature photo"} loading="lazy"
                className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute right-2 top-2 opacity-100 transition-opacity md:opacity-0 md:group-hover:opacity-100">
                <ShareButton id={p.id} title={p.title} />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                <p className="line-clamp-1 text-sm font-bold text-white">{p.title || "Untitled"}</p>
                {species.length > 0 && (
                  <div className="mt-1 flex flex-wrap gap-1">
                    {species.map((s) => (
                      <span key={s}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate(`/species/${encodeURIComponent(s)}`); }}
                        className="cursor-pointer rounded-full bg-emerald-500/90 px-2 py-0.5 text-[10px] font-semibold text-white hover:bg-emerald-400">{s}</span>
                    ))}
                  </div>
                )}
              </div>
            </Link>
          );
        })}
      </div>
      <Link to="/nature-pulse" className="mt-4 inline-flex items-center gap-0.5 text-sm font-bold text-emerald-700 hover:underline sm:hidden">
        View all nature photos <CaretRight size={14} weight="bold" />
      </Link>
    </section>
  );
}
